import { Component, OnInit } from '@angular/core';
import { GlobalService } from '../../global.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Service } from '../../services';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from "rxjs";
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material';
import { ReferredTermsComponent } from '../../referred/components/referred-terms/referred-terms.component';
import { PopupInternalreferredValidateemailComponent } from '../../referred/components/popup-internalreferred-validateemail/popup-internalreferred-validateemail.component';
import { LoadingScreenService } from '../../services/loading-screen/loading-screen.service';
import { AngularFireAnalytics } from '@angular/fire/analytics';
@Component({
  selector: 'app-internalreferred',
  templateUrl: './internalreferred.component.html',
  styleUrls: ['./internalreferred.component.sass']
})
export class InternalreferredComponent implements OnInit {
  sendEmailForm: FormGroup;
  public postpago;
  public prepago;
  public telefoniaFijo;
  public totalAccountList;
  public currentList;
  public selectBan;
  public type;
  public subscriber;
  public token: string = sessionStorage.getItem("token");
  public objItems: string = sessionStorage.getItem("objItems");
  public tabActive = 'Mis equipos y servicios';
  public screenView = 1;
  public screenActual;
  updateTypeAccount: Subscription;
  calculateCoupon: Subscription;
  public TotalAvailable = 0;
  public totalReferer = 0;
  public totalRedeem = 0;
  public CreditItems = [];
  public clickInvited = false;
  public checkTerms = false;
  public existeValido = false;
  public emailRegex = /^(?=[A-Z])[A-Z0-9_\-\.]+@(?=(([A-Z0-9_\-]+\.)+))\1[A-Z]{2,4}$/i;
  public emailsRefered = [];
  public emailReciever = "";
  public inform;
  public linkTwitter = 'https://twitter.com/intent/tweet?';
  public linkFacebook = 'http://www.facebook.com/sharer.php?';
  public linkEmail = '';
  public linkEmailTo = '';
  public linkWhatsapp = '';
  public linkWeb = '';
  public hasProcentageAsReferer = false;
  public countProcentageAsReferer = 0;
  public memberID = sessionStorage.getItem("memberID");
  public link = "";
  public socialMedia;
  public info;
  constructor(private router: Router, private loadingScreenService: LoadingScreenService, public global: GlobalService, private formBuilder: FormBuilder, private services: Service, public dialog: MatDialog, public AngularFireAnalytics: AngularFireAnalytics) {
    this.AngularFireAnalytics.setCurrentScreen("Refiere y Gana");
    this.AngularFireAnalytics.logEvent("Refiere y Gana-Screenview");
  }
  ngOnInit() {
    this.selectBan = atob(sessionStorage.getItem("selectBan"));
    this.info = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).SubscriberInfo;
    this.subscriber = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).SubscriberInfo[0].subscriberNumberField;
    this.updateTypeAccount = this.global.uptypeAccount.subscribe((value: string) => {
      this.type = value;
      this.getCreditsByAccount();
      this.processCreditsByAccount();
      this.getSharedItems();
    });
  }
  initializeData() { }
  refreshDataTo(event: Event) {
    this.initializeData();
  }
  mostrarPreguntasFrecuentes() {
    this.screenView = 2;
  }
  sharedCupons(emails, subscriber, account) {
    this.services.sharedCupons(this.token, this.memberID, this.link, this.emailReciever).subscribe(data => {
      this.loadingScreenService.stopLoading();
      if (data.hasError == false) {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.data = { screenActual: this.screenActual, emailReciever: this.emailReciever };
        this.dialog.open(PopupInternalreferredValidateemailComponent, dialogConfig);
      }
      else {
        this.global.notif(data.errorDisplay)
      }
    });
  }
  inviteFriends() {
    this.inform = document.getElementById('tags') as HTMLInputElement;
    this.clickInvited = true;
    if (this.checkTerms == true) {
      this.verificacionAlClickear();
    }
    else {
      this.global.notif("Debe seleccionar el campo de Términos y Condiciones para continuar.")
    }
  }

  termsCheckboxSelected(): boolean {
    this.mostarTerminos();
    return this.checkTerms == true;
  }
  verificacionAlClickear() {
    let cont=0;
    let contant=0;
    let emails=[];
    let indexEmail=0;
    while(cont!=-1){

        cont=this.emailReciever.indexOf(";",cont +1);
        if(cont==-1){
          emails[indexEmail]=(this.emailReciever.substr(contant,this.emailReciever.length)).trim()
        }else{
          emails[indexEmail]=(this.emailReciever.substr(contant,cont-contant)).trim()
        }
        indexEmail++;
        contant=cont+1;//esto
    }
        if(this.validarCorreos(emails)==true){
          this.verificacionAlClikearService(emails,0)
        }

  }
  validarCorreos(emails){
    let trueval=true;
    this.emailsRefered = [];
    for (let i = 0; i < emails.length; i++) {
      if (!this.emailRegex.test(emails[i])) {
        this.emailsRefered.push(emails[i]);
        if(emails[i]==""){
          this.global.notif("Debe ingresar al menos un correo válido.");
        }
        else{
          this.global.notif("El correo " + emails[i] + " no tiene un formato valido.");
        }
        trueval=trueval && false;
        break;
      }
      else{
        trueval=trueval && true;
      }
    }
     return trueval;
  }
  verificacionAlClikearService(emails,cont){
        this.loadingScreenService.startLoading();
          this.services.getVerifyEmail(emails[cont]).subscribe(data => {
            if (data.hasErrorField == false) {
              this.existeValido = true;
              if(cont<emails.length-1){
                cont++;
                this.verificacionAlClikearService(emails,cont)
              }
              else{
                this.sharedCupons(this.emailReciever, sessionStorage.referedValidSubscriber, sessionStorage.referedValidAccount);
              }
            }
            else {
              this.loadingScreenService.stopLoading();
              this.global.notif(data.errorDescField);
              this.emailsRefered.push(emails[cont]);
            }
          });
  }
  processSharedItems(data) {
    let text = encodeURI('Usted ha sido referido para disfrutar de descuentos al activar tu cuenta con Claro. Para más información favor de acceder al siguiente enlace para redimir su cupón y/o visitar una de nuestras localidades');
    this.socialMedia = data.objItems.slice().reverse();
    for (let i = 0; i < data.objItems.length; i++) {
      this.memberID = data.objItems[i].memberID;
      switch (data.objItems[i].socialMedia) {
        case 'facebook':
          this.linkFacebook += 'u=' + data.objItems[i].linkCode + '&t=' + text;
          //this.linkFacebook += 'u=https://miclaro.claropr.com/lnk.aspx?g=r-yAAAAA&t='+ text ;
          break;
        case 'twitter':
          this.linkTwitter += 'text=' + text + '&url=' + encodeURIComponent(data.objItems[i].linkCode);
          break;
        case 'whatsapp':
          this.linkWhatsapp = 'whatsapp://send?text=' + text + ' ' + encodeURIComponent(data.objItems[i].linkCode);
          break;
        case 'email':
          this.linkEmailTo = 'mailto:?subject=Mi Claro - Referidos&body=' + text + '%0D%0A%0D%0A' + encodeURIComponent(data.objItems[i].linkCode);
          this.linkEmail = text + '+%0D%0A%0D%0A+' + encodeURIComponent(data.objItems[i].linkCode);
          break;
        case 'web':
          this.linkWeb = encodeURIComponent(data.objItems[i].linkCode);
          this.link = data.objItems[i].linkCode;
          break;
        default:
          break;
      }
    }
  }
  copyLink() {
    var copyText;
    copyText = this.link;
    var aux = document.createElement('input');
    aux.setAttribute('value', copyText);
    document.body.appendChild(aux);
    aux.select();
    document.execCommand('copy');
    document.body.removeChild(aux);
  }
  mostarTerminos() {
    this.global.validateSession();
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = { checkTerms: this.checkTerms};
    const dialogRef = this.dialog.open(ReferredTermsComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(value => {
      if (value == "accept") {
        this.checkTerms = true;
      }
    });
  }
  share(data) {
    if (this.checkTerms == true) {
      switch (data) {
        case 'email':
          window.open(
            'https://mail.google.com/mail/u/0/?view=cm&fs=1&tf=1&su=Mi+Claro+-+Referidos&body=' +
            this.linkEmail +
            '&media=',
            'newwindow',
            'width=650,height=450'
          );
          break;
        case 'facebook':
          window.open(
            this.linkFacebook +
            '&media=',
            'newwindow',
            'width=650,height=450'
          );
          break;
        case 'twitter':
          window.open(this.linkTwitter +
            '&media=',
            'newwindow',
            'width=650,height=450'
          );
          break;
        case 'twitter2':
          window.open(this.linkWhatsapp +
            '&media=',
            'newwindow',
            'width=650,height=450'
          );
          break;
        default:
          break;
      }
    }
    else {
      this.global.notif("Debe seleccionar el campo de Términos y Condiciones para continuar.");
    }
  }
  getSharedItems() {
    this.services.getSharingMediaByUser(this.token, this.memberID, 1).subscribe(data => {
      if (data.hasError == false) {
        this.processSharedItems(data);
      }
      else {
        this.loadingScreenService.stopLoading();
        this.global.notif(data.errorDisplay);
        this.router.navigate(['home']);
      }
    });
  }
  getCreditsByAccount() {
    this.global.getCreditsByAccount(this.token, this.selectBan, "0", this.type);
    this.calculateCoupon = this.global.loadObserver2.subscribe((data: object) => {
      this.loadingScreenService.startLoading();
      this.countProcentageAsReferer = data["credit"];
      this.totalReferer=data["totalReferrs"];
      this.totalRedeem=data["totalRedeem"];
      this.loadingScreenService.stopLoading();
    });
  }
  processCreditsByAccount() {
    let index = 0;
    this.loadingScreenService.startLoading();
    this.services.getReferrAccountsAllStatus(this.token, 1, this.selectBan, this.info[index].subscriberNumberField).subscribe(data => {
      if (data.hasError == true) {
        this.loadingScreenService.stopLoading();
        this.global.notif(data.errorDisplay);
        this.router.navigate(['home']);
      }
    });
  }
  ngOnDestroy() {
    this.updateTypeAccount.unsubscribe();
  }
}
